import React from "react";
import {
  BiSupport,
  BiInfoCircle,
  BiHelpCircle,
  BiFileBlank,
  BiLock,
  BiLogOut,
} from "react-icons/bi";
import { HiEnvelope, HiPhone } from "react-icons/hi2";
import "../styles/Pages.css";

const MorePage = ({ user }) => {
  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      // Clear all auth data
      localStorage.removeItem("authToken");
      localStorage.removeItem("userData");
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminData");

      // Force a full page reload to /login
      window.location.href = "/login";
    }
  };

  const menuSections = [
    {
      title: "Support",
      items: [
        {
          icon: <BiSupport />,
          label: "Help Center",
          description: "Browse FAQs and guides",
        },
        {
          icon: <HiPhone />,
          label: "Contact Us",
          description: "Call: 0800 100 200",
        },
        {
          icon: <HiEnvelope />,
          label: "Email Support",
          description: "support@investec.com",
        },
        {
          icon: <BiHelpCircle />,
          label: "Live Chat",
          description: "Chat with an agent",
        },
      ],
    },
    {
      title: "Legal & Privacy",
      items: [
        {
          icon: <BiFileBlank />,
          label: "Terms of Service",
          description: "View terms and conditions",
        },
        {
          icon: <BiLock />,
          label: "Privacy Policy",
          description: "How we protect your data",
        },
        {
          icon: <BiFileBlank />,
          label: "Cookie Policy",
          description: "Manage cookie preferences",
        },
        {
          icon: <BiInfoCircle />,
          label: "Regulatory Information",
          description: "Compliance documents",
        },
      ],
    },
    {
      title: "About",
      items: [
        {
          icon: <BiInfoCircle />,
          label: "About Investec",
          description: "Our story and mission",
        },
        {
          icon: <BiFileBlank />,
          label: "Careers",
          description: "Join our team",
        },
        { icon: <BiInfoCircle />, label: "App Version", description: "v2.5.0" },
      ],
    },
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>More</h1>
        <p className="page-subtitle">Settings, support, and information</p>
      </div>

      <div className="user-info-card">
        <div className="user-avatar-large">
          {user?.firstName?.[0]}
          {user?.lastName?.[0]}
        </div>
        <h3>
          {user?.firstName} {user?.lastName}
        </h3>
        <p>{user?.email}</p>
        <span className="user-tier">Premium Member</span>
      </div>

      {menuSections.map((section, idx) => (
        <div key={idx} className="menu-section">
          <h3 className="section-title">{section.title}</h3>
          <div className="menu-list">
            {section.items.map((item, itemIdx) => (
              <button key={itemIdx} className="menu-item">
                <div className="menu-icon">{item.icon}</div>
                <div className="menu-content">
                  <h4>{item.label}</h4>
                  <p>{item.description}</p>
                </div>
                <div className="menu-arrow">›</div>
              </button>
            ))}
          </div>
        </div>
      ))}

      <div className="logout-section">
        <button className="logout-button" onClick={handleLogout}>
          <BiLogOut className="logout-icon" />
          <span>Logout</span>
        </button>
      </div>

      <div className="app-footer">
        <p>© 2026 Investec Bank. All rights reserved.</p>
        <p className="footer-links">
          <a href="#terms">Terms</a> · <a href="#privacy">Privacy</a> ·{" "}
          <a href="#security">Security</a>
        </p>
      </div>
    </div>
  );
};

export default MorePage;
